export default {
  path: '/mes',
  title: '云工厂',
  icon: 'sitemap',
  children: [
    {
      path: 'sewing',
      title: '工艺工序',
      icon: '',
      children: [
        {
          path: 'part',
          title: '工序部位',
          component: 'mes/sewing/part'
        },
        {
          path: 'level',
          title: '工序等级',
          component: 'mes/sewing/level'
        },
        {
          path: 'machineType',
          title: '机种',
          component: 'mes/sewing/machineType'
        },
        {
          path: 'wire',
          title: '线',
          component: 'mes/sewing/wire'
        },
        {
          path: 'needle',
          title: '针幅',
          component: 'mes/sewing/needle'
        },
        {
          path: 'process',
          title: '工序库',
          component: 'mes/sewing/process'
        },
        {
          path: 'craftGroup',
          title: '工艺组',
          component: 'mes/sewing/craftGroup'
        },
        {
          path: 'craft',
          title: '工艺库',
          component: 'mes/sewing/craft'
        },
        {
          path: 'style',
          title: '款式库',
          component: 'mes/sewing/style'
        },
        {
          path: 'styleProcess',
          title: '款式工序',
          component: 'mes/sewing/style/process',
          disableMenu: true
        },
        {
          path: 'styleCraft',
          title: '款式工艺',
          component: 'mes/sewing/style/craft',
          disableMenu: true
        }
      ]
    },
    {
      path: 'quality',
      title: '质检管理',
      icon: '',
      children: [
        {
          path: 'classify',
          title: '质检分类',
          component: 'mes/quality/classify'
        },
        {
          path: 'project',
          title: '质检项目',
          component: 'mes/quality/project'
        },
        {
          path: 'style',
          title: '款式质检项',
          component: 'mes/quality/style'
        },
        {
          path: 'styleQuality',
          title: '设置质检项',
          component: 'mes/quality/style/quality',
          disableMenu: true
        }
      ]
    },
    {
      path: 'factory',
      title: '工厂管理',
      icon: '',
      children: [
        {
          path: 'cubicle',
          title: '工位管理',
          component: 'mes/factory/cubicle'
        },
        {
          path: 'device',
          title: '设备管理',
          component: 'mes/factory/device'
        },
        {
          path: 'skill',
          title: '技能等级',
          component: 'mes/factory/skill'
        },
        {
          path: 'staffSkill',
          title: '员工技能',
          component: 'mes/factory/staffSkill'
        }
      ]
    },
    {
      path: 'order',
      title: '订单管理',
      icon: '',
      children: [
        {
          path: 'produce',
          title: '计划排产',
          component: 'mes/order/produce'
        },
        {
          path: 'produceProcess',
          title: '订单排产',
          component: 'mes/order/produce/process',
          disableMenu: true
        }
      ]
    }
  ]
}
